module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "window",
    class: {
      'window-active': _vm.isActive
    }
  }, [(_vm.background) ? _c('div', {
    staticClass: "backdrop",
    style: ({
      'z-index': _vm.zLevel
    }),
    on: {
      "click": _vm.onBackgroundClick
    }
  }) : _vm._e(), _c('div', {
    staticClass: "window-content",
    class: _vm.position,
    style: ({
      'z-index': Number(_vm.zLevel) + 1
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51ca76be","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PopWindow.vue
// module id = 572
// module chunks = 85